/*
 *###############################################################################
 *Module Name                   : PaymentModeHedContent.js                      #
 *Purpose of the Module         : Create/Modify Payment Modes and Sub types     #
 *Description of the Module     :                                               #
 *Original Author               : M A P A Wijetunge                             #
 *Date                          : Wednesday, August 25th 2021, 2:00:46 pm       #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */

import React, { useState } from "react"
import {
  Col,
  Row,
  Button,
  Label
} from "reactstrap"

//**Importing required componant files   */
import DPTextBox from "../../../framework/components/DPTextBox"
import DPSwitch from "framework/components/DPSwitch"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/Paymode.xlsx";
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
import { useEffect } from "react"
//**End Importing required componant files */

const PaymentModeHedContent = ({
  Hed_Code, //Get or set the current value of Code to the PaymentMode.js
  Hed_Code_OnChange, //Get or set the current value of code when the onChange event is triggered to the PaymentMode.js for input validations
  Hed_Code_onKeyPress,
  onBlur,
  Hed_Desc,
  Hed_Desc_OnChange,
  Hed_MaxLimit,
  Hed_MaxLimit_OnChange,
  Hed_DispSeq,
  Hed_DispSeq_OnChange,
  Hed_APIParam,
  Hed_APIParam_OnChange,
  Hed_Active,
  Hed_Active_OnChange,
  Hed_LinkDetail,
  Hed_LinkDetail_OnChange,
  Hed_LinkLoyalty,
  Hed_LinkLoyalty_OnChange,
  Hed_OverPay,
  Hed_OverPay_OnChange,
  Hed_GV,
  Hed_GV_OnChange,
  Hed_Credit,
  Hed_Credit_OnChange,
  Hed_Promotion,
  Hed_Promotion_OnChange,
  Hed_Refunds,
  Hed_Refunds_OnChange,
  Hed_Default,
  Hed_Default_OnChange,
  Hed_SignOff,
  Hed_SignOff_OnChange,
  Hed_SelectRowSearch, // Selected row of the Search window
  Hed_CodeSearchTrigger, // Calls when search window is required to be poped up
  Hed_CodeSearchOpen, // Open status of the Search window
  HedDataSearch,//Load data to Paymode head search box
  intPointOnChange,
  intPoint,
  intPointBlur,
  Disable,
  DisableCode,
  menuName,
  onButtonClick,
  btnDisable,
  SearchDisable,
  showFileUpload,
  valueUpload,
  menuCode,
  Hed_MaxLimit_OnBlur,
  autoCode
}) => {

  const [HeadColumns, setHeadColumns] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")
  const ApiURL = window.Links.ApiURL


  useEffect(async () => {
    setHeadColumns(await loadPopupSearchPay(menuCode, 'PAYMODEHED'))
  }, [menuCode]);


  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //********************************************/

  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={6} className="mb-4-sm">
          <Row>
            <Col>
              <DPTextBoxButton
                rowClass="mb-4-sm"
                labelText="Code *"
                textType="text"
                value={Hed_Code}
                onChange={Hed_Code_OnChange}
                onKeyPress={Hed_Code_onKeyPress}
                onBlur={onBlur}
                disabled={Disable == true ? Disable : DisableCode}
                onButtonClick={onButtonClick}
                btnDisable={Disable == true ? Disable : btnDisable}
                placeholder={autoCode}
              />
            </Col>
            <Col sm={12} md={1} className="mb-4-sm">
              <Button
                onClick={HedDataSearch}
                color="success"
                className="btn-sm"
                disabled={SearchDisable}
              >
                <i
                  className="mdi mdi-search-web"
                  style={{ fontSize: "12px" }}
                ></i>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <DPTextBox
                rowClass="mb-4-sm"
                labelText="Description *"
                textType="text"
                value={Hed_Desc}
                onChange={Hed_Desc_OnChange}
                disabled={Disable}
              />
            </Col>
            <Col sm={12} md={1} className="mb-4-sm"></Col>
          </Row>
          <Row>
            <Col>
              <DPTextBox
                rowClass="mb-4-sm"
                labelText="Maximum Limit *"
                textType="text"
                textAlign="right"
                value={Hed_MaxLimit}
                onChange={Hed_MaxLimit_OnChange}
                onBlur={Hed_MaxLimit_OnBlur}
                disabled={Disable}
              />
            </Col>
            <Col sm={12} md={1} className="mb-4-sm"></Col>
          </Row>
          <Row>
            <Col>
              <DPTextBox
                rowClass="mb-4-sm"
                labelText="Display Sequence *"
                textType="text"
                textAlign="right"
                value={Hed_DispSeq}
                onChange={Hed_DispSeq_OnChange}
                disabled={Disable}
              />
            </Col>
            <Col sm={12} md={1} className="mb-4-sm"></Col>
          </Row>
          <Row>
            <Col>
              <DPTextBox
                rowClass="mb-4-sm"
                labelText="API Parameters"
                textType="text"
                value={Hed_APIParam}
                onChange={Hed_APIParam_OnChange}
                disabled={Disable}
              />
            </Col>
            <Col sm={12} md={1} className="mb-4-sm"></Col>
          </Row>
          {Hed_LinkLoyalty ?
            <Row>
              <Col>
                <DPTextBox
                  rowClass="mb-4-sm"
                  labelText="Point Rate"
                  textType="text"
                  textAlign="right"
                  value={intPoint}
                  onChange={intPointOnChange}
                  onBlur={intPointBlur}
                  disabled={Disable}
                />
              </Col>
              <Col sm={12} md={1} className="mb-4-sm"></Col>
            </Row> : null}
        </Col>
        <Col sm={12} md={5} className="mb-4-sm">
          <Row>
            <Col>
              <Row>
                <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Active
                  </Label>
                </Col>
                <Col >
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_Active_OnChange}
                    checked={Hed_Active}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Linked to Details
                  </Label>
                </Col>
                <Col>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_LinkDetail_OnChange}
                    checked={Hed_LinkDetail}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Linked to Loyalty
                  </Label>
                </Col>
                <Col>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_LinkLoyalty_OnChange}
                    checked={Hed_LinkLoyalty}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Allow Over Payments
                  </Label>
                </Col>
                <Col>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_OverPay_OnChange}
                    checked={Hed_OverPay}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Linked to Gift Vouchers
                  </Label>
                </Col>
                <Col>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_GV_OnChange}
                    checked={Hed_GV}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Linked to Credit Payments
                  </Label>
                </Col>
                <Col>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_Credit_OnChange}
                    checked={Hed_Credit}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Linked to Promotions
                  </Label>
                </Col>
                <Col>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_Promotion_OnChange}
                    checked={Hed_Promotion}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Allow Refunds
                  </Label>
                </Col>
                <Col >
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_Refunds_OnChange}
                    checked={Hed_Refunds}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Default Payment mode
                  </Label>
                </Col>
                <Col>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_Default_OnChange}
                    checked={Hed_Default}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
              <Col style={{ textAlign: "left" }}>
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >
                    Display in Signoff
                  </Label>

                </Col>
                <Col>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={Hed_SignOff_OnChange}
                    checked={Hed_SignOff}
                    disabled={Disable}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          {/* <Row>
            <Col>
              <Row>
                <Col md={3}>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={SetPayHedLinkMyPay}
                    checked={blPayHedLinkMyPay}
                    disabled={Disable}
                  />
                </Col>
                <Col style={{ textAlign: "left" }}>Link With myPay</Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col md={3}>
                  <DPSwitch
                    rowClass={"mb-4-sm"}
                    height={23}
                    handleDiameter={15}
                    onChange={SetPayHedLinkWithOverPay}
                    checked={blPayHedLinkWithOverPay}
                    disabled={Disable}
                  />
                </Col>
                <Col style={{ textAlign: "left" }}>Link with OverPay</Col>
              </Row>
            </Col>
          </Row> */}
        </Col>
        <Col sm={12} md={1} className="mb-4-sm">
          <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
            <li className="import-export-button" style={{ display: "block" }}>
              <input
                id="file"
                type="file"
                onChange={showFileUpload}
                value={valueUpload}
                disabled={DisableCode}
                accept=".xlsx, .xls, .csv"
                style={{ display: "none" }}
              />

              <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: DisableCode == true ? "0.5" : "1" }}>
                <span >
                  <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                </span>
              </label></li>

            <li className="import-export-button" style={{ display: "block" }}>
              <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                style={{ pointerEvents: DisableCode ? 'none' : '', }} >
                <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: DisableCode == true ? "0.5" : "1" }}></img>
              </a></li>
          </ul>
        </Col>
        {/* <DPSearchBox
          searchData={DataTables}
          columns={columns}
          defaultSorted={defaultSorted}
          mainTitle={menuName + " Search"}
          SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={Hed_CodeSearchOpen}
          toggle={Hed_CodeSearchTrigger}
          getSelect={Hed_SelectRowSearch}
        /> */}

        <DPSearchBoxDynamic
          searchData={[]}
          columns={HeadColumns}
          defaultSorted={defaultSorted}
          mainTitle={menuName + " Search"}
          SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
          isOpen={Hed_CodeSearchOpen}
          toggle={Hed_CodeSearchTrigger}
          getSelect={Hed_SelectRowSearch}
          APIURL={ApiURL}
          URLPath={"PAYMODEHED"}
          MenuCode={menuCode}
          KeyVal={"MOD"}
          searchBy={"PH_CODE"}
          FilterStr={groupFilter}
        />

      </Row>
    </React.Fragment>
  )
}
export default PaymentModeHedContent
